// extracted by mini-css-extract-plugin
module.exports = {"tooltipBlock":"Tooltip_tooltipBlock__36UW-"};